import styled from '@emotion/styled';
import BasicModal from 'components/Modals/presets/BasicModal';

export const StyledModal = styled(BasicModal)`
  & .modal-body {
    overflow: visible;
  }
`;
